import React, { createContext, useContext, useState, ReactNode } from 'react';

type ProviderValue = {
  quickUploadFile: File | null;
  setQuickUploadFile: (file: File | null) => void;
};

const QuickUploadFileContext = createContext<ProviderValue>({
  quickUploadFile: null,
  setQuickUploadFile: (file: File | null) => {},
});

export const useQuickUploadFile = () => useContext(QuickUploadFileContext);

export const QuickUploadFileProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [quickUploadFile, setQuickUploadFile] = useState<File | null>(null);

  return (
    <QuickUploadFileContext.Provider
      value={{ quickUploadFile, setQuickUploadFile }}
    >
      {children}
    </QuickUploadFileContext.Provider>
  );
};
